<template>
  <v-container class="form-comissoes">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <v-form>
        <input
          id="user-id"
          type="hidden"
          v-model="comissao.usuario"
        />
        <input
          id="comissao-id"
          type="hidden"
          v-model="comissao.id"
        />
        <input
          id="comissao-uuid"
          type="hidden"
          v-model="comissao.uuid"
        />
        <v-row>
          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="codigo"
              label="Código"
              dense
              outlined
            >
              <v-icon
                slot="append"
                color="success"
                large
                @click="loadDialog"
              >
                mdi-magnify
              </v-icon>
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="3"
            lg="2"
          >
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-mask="datain"
                  v-model="data_ini"
                  label="Data de cadastro.:"
                  dense
                  outlined
                  @blur="mudaDataA"
                >
                  <v-icon
                    slot="append"
                    color="success"
                    large
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-calendar
                  </v-icon>
                </v-text-field>
              </template>
              <v-date-picker
                locale="pt-br"
                v-model="date"
                @input="dateA"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            md="2"
            lg="2"
          >
            <v-text-field
              v-model="comissao.ano_inicio"
              label="Ano inicial.:"
              dense
              outlined
            >
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="2"
            lg="2"
          >
            <v-text-field
              v-model="comissao.ano_termino"
              label="Ano final.:"
              dense
              outlined
            >
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="3"
            v-if="codigo"
          >
            <v-checkbox
              v-model="comissao.inativar"
              label="Inativar?"
              color="success"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="3"
            lg="2"
          >
            <v-text-field
              v-model="comissao.nome"
              label="Nome"
              dense
              outlined
              hint="Exemplo: para conselho tutetal = CTR, 3 letras em caixa alta"
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="9"
            lg="10"
          >
            <v-text-field
              v-model="comissao.titulo"
              label="Título"
              dense
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-card>
          <v-tabs
            background-color="primary"
            dark
            v-model="tabs"
          >
            <v-tab>
              <v-icon>
                mdi-history
              </v-icon>
              Observações
            </v-tab>
            <v-tab
              :disabled="!comissao.id"
              @click="loadMembros"
            >
              <v-icon>
                mdi-account-tie-outline
              </v-icon>
              Agentes Pub.
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabs">
            <v-tab-item>
              <v-card flat>
                <v-row>
                  <v-col colls="12">
                    <v-card class="pa-2">
                      <ckeditor
                        :editor="editor"
                        v-model="comissao.ds_comissao"
                        :config="editorConfig"
                        placeholder="Observação..."
                      ></ckeditor>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card>
                      <v-data-table
                        :headers="headersMembros"
                        :items="membros"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadMembro(item)"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon
                            medium
                            color="error"
                            class="mr-2"
                            @click="loadMembro(item)"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-btn
                            color="success"
                            class="ml-1 mb-3"
                            v-if="codigo"
                            @click="AddMembro"
                          >
                            <v-icon left>
                              mdi-content-save
                            </v-icon>
                            Novo Agente
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
        <v-row class="mt-1">
          <v-col
            cols="12"
            md="8"
          >
            <v-btn
              color="success"
              class="ml-1 mr-4"
              v-if="!comissao.id"
              @click="save"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Salvar
            </v-btn>
            <v-btn
              color="success"
              class="ml-1 mr-4"
              v-if="comissao.id"
              @click="save"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Atualizar
            </v-btn>
            <v-btn
              color="error"
              class="mr-4"
              v-if="comissao.id"
              @click="remove"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Deletar
            </v-btn>
            <v-btn
              color="secondary"
              class="mr-4"
              @click="reset"
            >
              <v-icon left>
                mdi-broom
              </v-icon>
              Limpar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-row justify="space-around">
        <v-col cols="auto">
          <v-dialog
            v-model="dialog"
            transition="dialog-bottom-transition"
            fullscreen
          >
            <template v-slot:default="dialog">
              <v-card>
                <v-toolbar
                  color="primary"
                  dark
                >
                  Pesquisar
                </v-toolbar>
                <v-card-title>
                  <v-text-field
                    class="search"
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisar"
                    single-line
                    hide-details
                  >
                  </v-text-field>
                </v-card-title>
                <v-data-table
                  :headers="headers"
                  :items="comissoes"
                  :search="search"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      large
                      color="success"
                      class="mr-2"
                      @click="loadComissao(item)"
                    >
                      mdi-arrow-down-bold-box
                    </v-icon>
                  </template>
                </v-data-table>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="error"
                    @click="dialog.value = false"
                  >Fechar</v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-col>
      </v-row>
      <v-container>
        <v-dialog
          v-model="DialogAgente"
          transition="dialog-top-transition"
        >
          <v-card
            class="py-4 px-2 auth-content"
            tile
          >
            <v-form>
              <input
                id="user-id"
                type="hidden"
                v-model="membro.usuario"
              />
              <input
                id="membro-id"
                type="hidden"
                v-model="membro.id"
              />
              <input
                id="membro-comissao"
                type="hidden"
                v-model="membro.uid_cmp"
              />
              <v-row>
                <v-col
                  cols="12"
                  md="7"
                  lg="6"
                >
                  <v-autocomplete
                    v-model="membro.uid_vereador"
                    :items="agentesGestao"
                    dense
                    outlined
                    label="Agente público"
                  ></v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                  lg="5"
                >
                  <v-autocomplete
                    v-model="membro.uid_cargo"
                    :items="cargos"
                    dense
                    outlined
                    label="Cargo do agente"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-form>
            <v-card-actions class="justify-center">
              <v-btn
                color="success"
                class="mr-4"
                v-if="codigo"
                type="submit"
                @click="adicionarAgente"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Adicionar
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                v-if="codigo"
                type="submit"
                @click="adicionarAgenteSair"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Adicionar e sair
              </v-btn>
              <v-btn
                color="error"
                class="mr-4"
                v-if="codigo"
                @click="limpar"
              >
                Limpar
                <v-icon left>
                  mdi-broom
                </v-icon>
              </v-btn>
              <v-btn
                color="danger"
                class="mr-4"
                @click="FecharDialog"
              >
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-card>
  </v-container>
</template>
<script>
import { mapState } from 'vuex'
import { uuid } from 'vue-uuid'
import { baseApiUrl, showError } from '@/global'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import moment from 'moment'
import axios from 'axios'
export default {
  name: 'FormComissoes',
  computed: mapState(['user']),
  data: () => ({
    editor: ClassicEditor,
    editorConfig: {
    },
    uuid: '',
    datain: '##/##/####',
    tabs: null,
    codigo: '',
    dialog: false,
    DialogAgente: false,
    loading: false,
    search: null,
    select: null,
    date: new Date().toISOString().substr(0, 10),
    data_ini: '',
    menu: false,
    mode: 'save',
    listar: '',
    comissao: {},
    membro: {},
    pessoa: {},
    items: [],
    membros: [],
    agentesGestao: [],
    cargos: [],
    comissoes: [],
    length: '',
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Título', value: 'titulo' },
      { text: 'Início', value: 'ano_inicio' },
      { text: 'Término', value: 'ano_termino' },
      { text: 'Situação', value: 'situacao', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersMembros: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Agente público', value: 'nome' },
      { text: 'Cargo', value: 'cargo' },
      { text: 'Data', value: 'publicacao', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    valid: false
  }),
  methods: {
    mudaDataA () {
      const [dia, mes, ano] = this.data_ini.split('/')
      if (this.data_ini) {
        this.comissao.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    dateA () {
      this.data_ini = moment(this.date).format('DD/MM/YYYY')
      this.menu = false
      const [dia, mes, ano] = this.data_ini.split('/')
      this.comissao.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },

    endereco () {

    },
    fone () {

    },
    histori () {

    },
    validate () {
      this.$refs.form.validate()
    },
    save () {
      const method = this.comissao.id ? 'put' : 'post'
      const id = this.comissao.id ? `/${this.comissao.id}` : ''
      axios[method](`${baseApiUrl}/admin-comissoes-permanentes${id}`, this.comissao)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    saveAgente () {
      const method = this.membro.id ? 'put' : 'post'
      const id = this.membro.id ? `/${this.membro.id}` : ''
      axios[method](`${baseApiUrl}/items-de-comissoes-permanentes${id}`, this.membro)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.limpar()
          this.loadMembros()
        })
        .catch(showError)
    },
    remove () {
      const id = this.comissao.id
      if (confirm('Deseja realmente deletar esta comissão permanente?')) {
        axios.delete(`${baseApiUrl}/admin-comissoes-permanentes/${id}`)
          .then(() => {
            this.$toasted.global.defaultSuccess()
            this.reset()
          })
          .catch(showError)
      }
    },
    loadMembros () {
      const id = this.comissao.id
      const url = `${baseApiUrl}/items-de-comissoes-por-comissao/${id}`
      axios.get(url).then(res => {
        this.membros = res.data.map(item => {
          return {
            ...item,
            dtin: moment(item.data_inicio).format('DD/MM/YYYY'),
            dtfi: moment(item.data_termino).format('DD/MM/YYYY')
          }
        })
      })
    },
    loadComissoes () {
      const url = `${baseApiUrl}/admin-comissoes-permanentes`
      axios.get(url).then(res => {
        this.comissoes = res.data.map(item => {
          return {
            ...item,
            situacao: item.inativar === 0 ? 'Ativo' : 'Inativo'
          }
        })
      })
    },
    loadComissao (item) {
      const url = `${baseApiUrl}/admin-comissoes-permanentes/${item.id}`
      axios.get(url).then(res => {
        this.comissao = res.data
        this.codigo = this.comissao.id
        if (!this.comissao.data_publicacao) {
          this.data_ini = ''
        } else {
          this.data_ini = moment(this.comissao.data_publicacao).format('DD/MM/YYYY')
          this.comissao.data_publicacao = moment(this.comissao.data_publicacao).format('YYYY-MM-DD')
        }
      })
      this.dialog = false
    },
    loadPedidoPessoaId (item) {
      const id = this.vereador.uid_pessoa ? `/${this.vereador.uid_pessoa}` : `/${item.uid_pessoa}`
      const url = `${baseApiUrl}/vereador-por-id${id}`
      axios.get(url).then(res => {
        this.pessoa = res.data
        this.vereador.uid_pessoa = this.pessoa.uid_pessoa
        this.vereador.vereador = this.pessoa.vereador
        this.vereador.cpf = this.pessoa.cpf
        this.vereador.cpf_txt = this.pessoa.cpf_txt
      })
      this.clPessoa()
    },
    clPessoa () {
      this.vereador.uid_pessoa = ''
      this.vereador.vereador = ''
      this.vereador.cpf = ''
      this.vereador.cpf_txt = ''
      this.items = []
      this.listar = ''
    },
    loadSeach (listar = 'sim') {
      const search = this.vereador.vereador || 0
      const url = `${baseApiUrl}/vereador-search/${search}`
      axios.get(url).then(res => {
        this.items = res.data
      })
      this.listar = listar
    },
    loadFtPessoa () {

    },
    loadAddPessoa () {

    },
    AddMembro () {
      this.loadAgentesGestao()
      this.loadCargos()
      this.membro.usuario = this.user.id
      this.membro.uid_cmp = this.comissao.id
      this.DialogAgente = true
    },
    reset () {
      this.mode = 'save'
      this.codigo = ''
      this.diretoria = {}
      this.comissao = {}
      this.membro = {}
      this.membros = []
      this.vereadores = []
      this.dateA()
    },
    limpar () {
      this.mode = 'save'
      this.membro = {}
    },
    FecharDialog () {
      this.DialogAgente = false
      this.limpar()
    },
    adicionarAgente () {
      this.saveAgente()
    },
    adicionarAgenteSair () {
      this.saveAgente()
      this.DialogAgente = false
    },
    loadDialog () {
      this.dialog = true
      this.loadComissoes()
    },
    loadAgentesGestao () {
      const id = this.comissao.uid_mandato
      const url = `${baseApiUrl}/vereadores-da-legislatura/${id}`
      axios.get(url).then(res => {
        this.agentesGestao = res.data.map(item => {
          return {
            value: item.id,
            text: `${item.vereador}`
          }
        })
      })
    },
    loadCargos () {
      const url = `${baseApiUrl}/cargos-e-funcoes`
      axios.get(url).then(res => {
        this.cargos = res.data.map(cargos => {
          return {
            value: cargos.id,
            text: `${cargos.cargo}`
          }
        })
      })
    },
    loadUser () {
      this.comissao.usuario = this.user.id
      this.comissao.uuid = uuid.v1()
    }
  },
  mounted () {
    const id = this.$route.params.id
    if (id) {
      const url = `${baseApiUrl}/admin-comissoes-permanentes/${id}`
      axios.get(url)
        .then(res => {
          const data = res.data
          this.comissao = data
          this.codigo = data.id
          // Tratamento da data
          if (data.data_publicacao) {
            const dataPublicacao = moment(data.data_publicacao)
            this.data_ini = dataPublicacao.format('DD/MM/YYYY')
            this.comissao.data_publicacao = dataPublicacao.format('YYYY-MM-DD')
          } else {
            this.data_ini = ''
          }
        })
        .catch(err => {
          console.error('Erro ao carregar comissão:', err)
        })
    }
    this.loadUser()
  }
}
</script>
